import type { Giveaway } from '@/models/giveaway'

/**
 * The wizard's steps.
 *
 * The Vue version used bare numbers with two magic values wedged in — 998 for
 * "add a custom game" and 999 for "paste keys" — because both are detours off
 * step 1 rather than steps of their own. Naming them keeps the branching in
 * GiveawayNew readable.
 */
export type WizardStep = 'basics' | 'details' | 'objectives' | 'review' | 'keys' | 'custom-game'

export const FIRST_STEP: WizardStep = 'basics'

/** Linear order of the four real steps, for Back/Next and the step rail. */
export const STEP_ORDER: WizardStep[] = ['basics', 'details', 'objectives', 'review']

export const STEP_LABELS: Record<WizardStep, string> = {
  basics: 'Prize',
  details: 'Details',
  objectives: 'Entry',
  review: 'Review',
  keys: 'Keys',
  'custom-game': 'Game',
}

/**
 * Which of the four rail positions a step belongs to. The two detours sit
 * under the step they were opened from, so the rail never jumps backwards.
 */
export function railStep(step: WizardStep): WizardStep {
  return step === 'keys' || step === 'custom-game' ? 'basics' : step
}

export function nextStep(step: WizardStep): WizardStep {
  const index = STEP_ORDER.indexOf(step)
  if (index === -1 || index === STEP_ORDER.length - 1) return step
  return STEP_ORDER[index + 1]
}

export function previousStep(step: WizardStep): WizardStep {
  const index = STEP_ORDER.indexOf(step)
  if (index <= 0) return STEP_ORDER[0]
  return STEP_ORDER[index - 1]
}

export interface StepProps {
  giveaway: Giveaway
  update: (mutate: (draft: Giveaway) => void) => void
  onBack: () => void
  onNext: () => void
}
